import { Heart, Sparkles, Shield } from "lucide-react";

/**
 * ActivePerksBadge (iter67) — compact HUD strip showing which in-run perks
 * the player has drafted this run. Lives in the sidebar near StatsHUD.
 */
const META = {
  max_hp_15:      { icon: Heart,    label: "+15% MAX HP",       title: "Flesh of the Deep" },
  hp_regen_2:     { icon: Sparkles, label: "+2 HP / TURN",      title: "Ember Mend" },
  shield_on_kill: { icon: Shield,   label: "SHIELD ON KILL",    title: "Reaper's Ward" },
};

export default function ActivePerksBadge({ activePerks = [] }) {
  if (!activePerks || activePerks.length === 0) return null;
  return (
    <div className="panel p-3" data-testid="active-perks-badge">
      <div className="text-[10px] tracking-[0.3em] ash-text mb-2">— BOONS —</div>
      <div className="flex flex-col gap-2">
        {activePerks.map((key) => {
          const m = META[key];
          if (!m) return null;
          const Icon = m.icon;
          return (
            <div
              key={key}
              className="flex items-center gap-2 text-[11px]"
              data-testid={`perk-badge-${key}`}
              title={m.title}
            >
              <Icon size={14} className="gold-text" />
              <span className="font-heading tracking-wider gold-text">{m.label}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
